import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'alpha'
})
export class AlphaPipe implements PipeTransform {

  transform(value: any): string {
    const parsed = Number.parseInt(value, 10);
    if (Number.isNaN(parsed)) {
      return value
    } else {
      return parsed.toString()
    }

  }

}
